import { initialState } from '../../../reducer/auth_reducer';

export const authInitialState = initialState;
